class DatatableService {
  constructor($rootScope, $http, $filter, emittentenService) {
    'ngInject';
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$filter = $filter;
    this.emittentenService = emittentenService;

    if (this.$rootScope.language === 'de') {
      this.weekDayWrapper = {
        0: 'Mo',
        1: 'Di',
        2: 'Mi',
        3: 'Do',
        4: 'Fr',
        5: 'Sa',
        6: 'So',
      };
    } else {
      this.weekDayWrapper = {
        0: 'Mo',
        1: 'Tue',
        2: 'Wed',
        3: 'Thu',
        4: 'Fri',
        5: 'Sat',
        6: 'Sun',
      };
    }
    this.strings = {
      de: {
        oneonone: 'nur 1-on-1',
        speaker: 'Referent',
      },
      en: {
        oneonone: 'only 1-on-1',
        speaker: 'Speaker',
      },
    };

    this.typeStrings = {
      de: [
        'NBU',
        'IN',
        'IN',
        'UN',
        'EM'
      ],
      en: [
        'NL',
        'IN',
        'IN',
        'EN',
        'IS'
      ],
    }
  }

  getCurrentEvent() {
    return this.$http
      .post(this.$rootScope.config.api2 + 'events/get', {
        search: { getLatestPublishedEvent: true },
      })
      .then(
        (result) => {
          return result.data[0];
        },
        (response) => {
          console.error(response);
        }
      );
  }

  getData(filter) {
    return new Promise((resolve, reject) => {
      this.emittentenService.getEventPackets('de', 1).then(
        (eventPackets) => {
          this.$http
            .post(this.$rootScope.config.api + 'events/getEventDataTable', {
              event_id: this.$rootScope.config.event_id,
              search: {
                sort: { pres_start_time: 1 },
              },
            })
            .then(
              (result) => {
                if (filter === 'eventDataKsu') {
                  result.data = this.$filter('filter')(result.data, {
                    user_type: 1,
                  });
                } else if (
                  filter == 'eventDataStock' ||
                  filter === 'eventDataAsset'
                ) {
                  result.data = this.$filter('filter')(result.data, {
                    user_type: 5,
                  });
                  if (filter === 'eventDataStock') {
                    var packetId = '!' + eventPackets[1].id;
                  } else {
                    var packetId = eventPackets[1].id;
                  }
                  result.data = this.$filter('filter')(result.data, {
                    event_packet_id: packetId,
                  });
                }
                angular.forEach(result.data, (value, key) => {
                  this.setTimes(value);
                  this.setReferent(value);
                  console.log(this.$rootScope.language)
                  if ([1,2,3,4].includes(value.user_type)) {
                    value.type = this.typeStrings[this.$rootScope.language][value.user_type - 1]
                  } else {
                    value.type = this.typeStrings[this.$rootScope.language][4]
                  }
                });
                resolve(result);
              },
              (response) => {
                console.error(response);
              }
            );
        },
        (response) => {
          console.error(response);
        }
      );
    });
  }

  setReferent(item) {
    if (!item.room_name) item.room_name = '';
    if (item.speaker_firstname) {
      item.speaker =
        this.strings[this.$rootScope.language].speaker +
        ': ' +
        item.speaker_firstname +
        ' ' +
        item.speaker_lastname;
    } else if (item.presentation_speaker_text) {
      item.speaker = this.strings[this.$rootScope.language].speaker + ': ' + item.presentation_speaker_text;
    } else {
      item.speaker = '';
    }
    if (item.would_like_to_present == 2) {
      item.start_time_string = this.strings[this.$rootScope.language].oneonone;
    }
    if (item.company_legal_form) {
      item.company_name = item.company_name + ' ' + item.company_legal_form;
    }
    if (item.presentation_language === 'de') {
      item.company_name = item.company_name + ' *';
    }
  }

  setTimes(item) {
    if (!item.pres_start_time) {
      item.start_time_string1 = '';
      item.start_time_string2 = '';
      return;
    }

    var dateStart = new Date(item.pres_start_time.replace(/-/g, '/'));
    var dateEnd = new Date(item.pres_end_time.replace(/-/g, '/'));

    item.start_time_string1 = this.$filter('date')(
      dateStart,
      'EEE. dd.MM.yyyy',
      'de'
    );
    item.start_time_string2 =
      this.$filter('date')(dateStart, 'HH:mm') +
      ' - ' +
      this.$filter('date')(dateEnd, 'HH:mm');
  }
}

export default DatatableService;



// WEBPACK FOOTER //
// ./client/app/common/datatable/datatable.service.js